export default __webpack_public_path__ + "assets/step_2.08bf8f34.svg";